import React from "react";
import { Result } from "antd";

class Error extends React.Component {
    render() {
        return (
            <Result
                status={"404"}
                subTitle={"This Document Type is not Supported"}
            />
        );
    }
}

export default Error;